import { b2x } from '@b2x/react/src';

import { useAppContext } from './AppContext';
import { Container } from './Container';
import { t } from './i18n/i18n';

export interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const { hideHeader } = useAppContext();

  return (
    <>
      {!hideHeader && (
        <Container>
          <h1>
            <b2x.router.Link to="/">{t('misc.storeName')}</b2x.router.Link>
          </h1>
        </Container>
      )}
    </>
  );
};
